import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from '../ThemeContext';

export default function ScanlineOverlay() {
  const { isCyberpunk } = useTheme();

  return (
    <AnimatePresence>
      {isCyberpunk && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="scanline-overlay"
        />
      )}
    </AnimatePresence>
  );
}
